import { render, staticRenderFns } from "./ScheduleViewSidebar.vue?vue&type=template&id=135daee4&scoped=true&"
import script from "./ScheduleViewSidebar.vue?vue&type=script&lang=js&"
export * from "./ScheduleViewSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleViewSidebar.vue?vue&type=style&index=0&id=135daee4&lang=scss&scoped=true&"
import style1 from "./ScheduleViewSidebar.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135daee4",
  null
  
)

export default component.exports